import type { ReactNode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { setPublicMotionBootMode } from '../components/public/PublicMotionProvider'

export function renderInertiaRoot(el: HTMLElement, app: ReactNode) {
  const hasSsrMarkup = el.hasChildNodes()
  setPublicMotionBootMode(hasSsrMarkup ? 'ssr' : 'csr')

  if (hasSsrMarkup) {
    hydrateRoot(el, app)
  } else {
    createRoot(el).render(app)
  }
}
